<template>
   <div class="d-flex justify-content-center align-items-center" style="height: 100vh;" v-if="ready">
      <b-row class="p-5">
        <b-col cols="12" class="mb-5" v-if="claims"> {{ $t('hello') }} <h5> {{ claims.Entity.name }} </h5> </b-col>
        <b-col cols="12" class="mb-3"> <h4> {{ $t('chooseYourEnvironment') }} </h4> </b-col>
        <b-col cols="6" md="3" v-for="project in projects" :key="project.uuid" @click="choosen(project)" style="cursor:pointer">
            <b-card>
                {{ project.name }}
            </b-card>
        </b-col>
      </b-row>

      <ReLogin v-model="showLogin" :project_uuid="loginTo" @success="successLogin"/>
   </div>
</template>

<script>
import ReLogin from '../users/ReLogin'

export default {
    components: {
        ReLogin
    },

    data: function() {
        return {
            showLogin: false,
            loginTo: null,
            ready: false
        }
    },

    methods: {
        choosen(project) {
            this.loginTo = project.uuid
            this.showLogin = true
        },

        successLogin() {
            localStorage.setItem("current_project_uuid", this.loginTo)
            this.$router.push({query: {}})
            this.$router.go("/home")
        },
    },

    computed: {
        projects() {
            return this.$store.getters.projects
        },

        claims() {
            return this.$store.getters.getClaims
        },

        currentProject() {
            return this.$store.getters.getCurrentProject
        },

        force() {
            return this.$route.query.force
        }
    },

    async created() {
        try {
            await this.$store.dispatch('fetchClaims')
            await this.$store.dispatch('fetchProjects')

            if (this.force) {
                this.ready = true
                return
            }

            if (!this.currentProject) {
                this.ready = true
            } else {
                this.$router.push("/home")
            }

        } catch (e) {
            console.error(e)
            if (e.response.status == 401) {
                this.$store.commit('setClaims', null)
                this.$router.push("/login")
            }
        }  
    }
}
</script>